const DEFAULT_CONFIG = {
  redBg: [],
  yellowBg: [],
  greenBgAndDots: [],
  greenBg: [],
};

const decorate = (config = DEFAULT_CONFIG) => {
  return (fp) => {
    const onDayCreate = (_selectedDates, _inputValue, _fp, dayElement) => {
      config.yellowBg.forEach(({ from, to }) => {
        const fromCond =
          dayElement.dateObj.getTime() >= new Date(from).setHours(0, 0, 0, 0);

        const toCond = to
          ? dayElement.dateObj.getTime() <= new Date(to).setHours(0, 0, 0, 0)
          : true;

        if (fromCond && toCond) {
          dayElement.classList.add("yellow-bg");
        }
      });

      config.redBg.forEach(({ from, to }) => {
        if (
          dayElement.dateObj.getTime() >= new Date(from).setHours(0, 0, 0, 0) &&
          dayElement.dateObj.getTime() <= new Date(to).setHours(0, 0, 0, 0)
        ) {
          dayElement.classList.add("red-bg");
        }
      });

      config.greenBg.forEach((date) => {
        if (
          new Date(date).setHours(0, 0, 0, 0) === dayElement.dateObj.getTime()
        ) {
          dayElement.classList.add("green-bg");
        }
      });

      config.greenBgAndDots.forEach((date) => {
        if (
          new Date(date).setHours(0, 0, 0, 0) === dayElement.dateObj.getTime()
        ) {
          dayElement.classList.add("green-bg-and-dot");
        }
      });
    };

    return {
      onDayCreate,
      onReady: [
        () => {
          fp.loadedPlugins.push("decorate");
        },
      ],
    };
  };
};

export default decorate;
